// noinspection ExceptionCaughtLocallyJS

import * as constants from '../constants';
import { POST_ERROR, PREFILL_DATA } from '../constants';
import { ACTION, setLoading, wrap } from './index';
import { Dispatch } from 'redux';
import { SchemaGetBasketDefinitionQueryParams } from '@repo/legacy-commerce-api';
import legacyApi from '../middlewares/api';

export const getUserData = (params: SchemaGetBasketDefinitionQueryParams) =>
  wrap(async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const { data, error } = await legacyApi.GET('/basketdefinition', { params: { query: params } });

      if (error) {
        throw JSON.stringify(error);
      }

      dispatch({ type: PREFILL_DATA, payload: data });

      return data;
    } catch (err) {
      console.error('Error: ', err);
      dispatch(setLoading(false));
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  }, POST_ERROR);

export const updateLocation = (payload: any): ACTION => ({
  type: constants.UPDATE_LOCATION_J3,
  payload,
});
